module.exports = __webpack_public_path__ + "static/2-30fe741e894766059c5a2a3258393ff2.jpg";